export default __webpack_public_path__ + "static/media/Vector.426398cd.svg";